import { useEffect, useState } from 'react';
import { TextWithContentModel } from '../../model/TextWithContentModel';
import { motion } from 'framer-motion';
import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';

interface MultipleImagesPreviewProps {
  content: TextWithContentModel;
}

export const MultipleImagesPreview = ({ content }: MultipleImagesPreviewProps) => {
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState('down'); // 'up' or 'down'

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    setScrollDirection(currentScrollY > lastScrollY ? 'down' : 'up');
    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);
  if (content.mediaType !== 2) return null;

  const parallaxEffect = {
    initial: { y: 0 },
    whileInView: scrollDirection === 'down' ? { y: -10 } : { y: 10 }, //tweek this value to adjust the parallax effect
    transition: { type: 'tween', ease: 'ease', duration: 2 },
  };

  return (
    <div className='flex min-[350px]:h-[400px] md:h-fit flex-col z-0'>
      <div className='flex justify-evenly w-full min-[350px]:gap-4 min-[350px]:px-4 md:gap-0 md:px-0'>
        {content.multipleImageContent[0] && content.multipleImageContent[0].url && (
          <motion.div {...parallaxEffect}>
            <CDNImage
              src={content.multipleImageContent[0].url}
              alt={content.multipleImageContent[0].alt}
              mobileWidth={125}
              mobileHeight={125}
              imageWidth={150}
              imageHeight={150}
              fit='crop'
              className='min-[350px]:mr-4 2xl:mr-20 lg:z-[3]'
            />
          </motion.div>
        )}
        {content.multipleImageContent[1] && content.multipleImageContent[1].url && (
          <motion.div {...parallaxEffect}>
            <CDNImage src={content.multipleImageContent[1].url} alt={content.multipleImageContent[1].alt} mobileWidth={225} mobileHeight={175} imageWidth={250} imageHeight={200} fit='crop' className='lg:z-[1]' />
          </motion.div>
        )}
      </div>
      <div className='flex justify-evenly -mt-4 min-[350px]:gap-4 min-[350px]:px-4 md:gap-0 md:px-0'>
        {content.multipleImageContent[2] && content.multipleImageContent[2].url && (
          <motion.div {...parallaxEffect}>
            <CDNImage
              src={content.multipleImageContent[2].url}
              alt={content.multipleImageContent[2].alt}
              mobileWidth={225}
              mobileHeight={175}
              imageWidth={250}
              imageHeight={200}
              fit='crop'
              className='min-[350px]:mr-4 2xl:mr-12 lg:z-[2]'
            />
          </motion.div>
        )}
        {content.multipleImageContent[3] && content.multipleImageContent[3].url && (
          <motion.div {...parallaxEffect}>
            <CDNImage src={content.multipleImageContent[3].url} alt={content.multipleImageContent[3].alt} mobileWidth={125} mobileHeight={125} imageWidth={150} imageHeight={150} fit='crop' className='mt-12 lg:z-[4]' />
          </motion.div>
        )}
      </div>
    </div>
  );
};
